import sitecoreIds from 'src/app_config/sitecore-ids.json';

export function isClinicalTopic(templateId?: string): boolean {
	return (
		templateId?.toLowerCase() === sitecoreIds.Templates.ClinicalTopicContentPageTemplateId.toLowerCase() ||
		templateId?.toLowerCase() === sitecoreIds.Templates.ClinicalTopicLandingPageTemplateId.toLowerCase()
	);
}

export function isLmsCourse(templateId?: string): boolean {
	return templateId?.toLowerCase() === sitecoreIds.Templates.LMSCourseTemplateId.toLowerCase();
}

export function isRcniCPDArticle(templateId?: string): boolean {
	return templateId?.toLowerCase() === sitecoreIds.Templates.RCNiCPDArticleTemplateId.toLowerCase();
}

export function isRcniLearningModule(templateId?: string): boolean {
	return templateId?.toLowerCase() === sitecoreIds.Templates.RCNiLearningModuleTemplateId.toLowerCase();
}

export function isResourcePage(templateId?: string): boolean {
	return templateId?.toLowerCase() === sitecoreIds.Templates.ResourcePageTemplateId.toLowerCase();
}

export function isResourceContentPage(templateId?: string): boolean {
	return templateId?.toLowerCase() === sitecoreIds.Templates.ResourceContentPageTemplateId.toLowerCase();
}

export function isTopicPage(templateId?: string): boolean {
	return templateId?.toLowerCase() === sitecoreIds.Templates.TopicPageTemplateId.toLowerCase();
}
